import { Trans } from '@lingui/react/macro';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import Notes from './notes';


function Modal({ device, dismiss }) {
  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3>
          <Trans>Notes for</Trans> <strong>{device?.name}</strong>
        </h3>
      </header>
      <section>
        <Notes device={device} />
      </section>
      <footer>
        <button onClick={dismiss}><Trans>Close</Trans></button>
      </footer>
    </I18nProvider>
  );
};

export default Modal;
